import { useCallback, useState } from 'react';

export const useDownloadingState = (
  onDownload?: () => void | Promise<void>,
  disabled?: boolean,
) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const onDownloadProxy = useCallback(() => {
    if (!onDownload || disabled) return;

    setIsDownloading(true);
    requestAnimationFrame(() => {
      try {
        const result = onDownload();

        if (result instanceof Promise) {
          result.finally(() => setIsDownloading(false));
        } else {
          setIsDownloading(false);
        }
      } catch {
        setIsDownloading(false);
      }
    });
  }, [onDownload, disabled]);

  return { isDownloading, onDownloadProxy };
};
